import React, { useState } from "react";
import EmpresasOpticas from "./EmpresasOpticas";
import PerfilesControlInformacion from "./PerfilesControlInformacion";
import Fidelizacion from "./Fidelizacion";

export default function AdministrationSettingsScreen(props) {
  const [selectedTab, setSelectedTab] = useState(0);

  if (!props.show) {
    return <></>;
  }

  return (
    <div>
      <div className="optometry-icon-header">
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 0 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(0);
          }}
        >
          <img
            src={
              selectedTab === 0
                ? "/images/optometry-orange.svg"
                : "/images/optometry-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Empresas y ópticas</span>
        </button>
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 1 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(1);
          }}
        >
          <img
            src={
              selectedTab === 1
                ? "images/anamnesis-orange.svg"
                : "/images/anamnesis-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Control de información</span>
        </button>
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 2 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(2);
          }}
        >
          <img
            src={
              selectedTab === 2
                ? "/images/rx-orange.svg"
                : "/images/rx-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Fidelización</span>
        </button>
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 3 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(3);
          }}
        >
          <img
            src={
              selectedTab === 3
                ? "/images/accommodative-orange.svg"
                : "/images/accommodative-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Calendario (festivos)</span>
        </button>
      </div>
      <div>
        {selectedTab === 0 && (
          <EmpresasOpticas {...props} show={selectedTab === 0} />
        )}
        {selectedTab === 1 && (
          <PerfilesControlInformacion {...props} show={selectedTab === 1} />
        )}
        {selectedTab === 2 && (
          <Fidelizacion {...props} show={selectedTab === 2} />
        )}
      </div>
    </div>
  );
}
